import React from "react";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import "./StyledTooltip.scss";

type StyledTooltipProps = {
  content?: React.ReactNode;
  children: React.ReactNode;
  placement?: "top" | "bottom" | "left" | "right";
  className?: string;
  disabled?: boolean;
};

const StyledTooltip: React.FC<StyledTooltipProps> = ({
  content,
  children,
  placement = "top",
  className,
  disabled = false,
}) => {
  if (!content) {
    return <>{children}</>;
  }

  return (
    <Tippy
      content={content}
      placement={placement}
      animation="shift-away"
      duration={100}
      delay={[0, 0]}
      hideOnClick={true}
      interactive={false}
      theme="dt"
      className={className}
      disabled={disabled}
      trigger="mouseenter focus"
    >
      <span className="dt-tooltip__trigger">{children}</span>
    </Tippy>
  );
};

export default StyledTooltip;
